"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LoadingIndicator = void 0;
var react_1 = __importDefault(require("react"));
require("./LoadingIndicator.scss");
var LoadingIndicator = function (props) { return (react_1.default.createElement(react_1.default.Fragment, null,
    react_1.default.createElement("div", { className: "loading-indicator" },
        react_1.default.createElement("i", { className: "fas fa-circle-notch fa-spin fa-6x" }),
        props.title),
    react_1.default.createElement("div", { className: "loading-overlay" }))); };
exports.LoadingIndicator = LoadingIndicator;
